<template>
    <d-col>
        <b-spinner class="m-auto" v-if="isLoading && !isLoaded" label="Spinning" />
        <div>
            <div class="form-group">
                <label>Account</label>
                <d-form-select
                    required
                    :value="selectedAccount"
                    @change="handleSelectingAccount"
                >
                    <option
                        v-for="account in accounts"
                        :key="account.id"
                        :value="account.id"
                    >
                        {{ account.name }} [{{ account.id }}]
                    </option>
                </d-form-select>
            </div>
            <div class="form-group">
                <label>Property</label>
                <d-form-select
                    required
                    :value="selectedProperty"
                    @change="handleSelectingProperty"
                >
                    <option
                        v-for="property in properties"
                        :key="property.id"
                        :value="property.id"
                    >
                        {{ property.name }} [{{ property.id }}]
                    </option>
                </d-form-select>
            </div>
            <div class="form-group">
                <label>Measurement ID</label>
                <d-form-select
                    required
                    :value="selectedMeasurement"
                    @change="handleSelectingMeasurement"
                >
                    <option
                        v-for="measurement in measurements"
                        :key="measurement.id"
                        :value="measurement"
                    >
                        {{ measurement.name }} [{{ measurement.id }}]
                    </option>
                </d-form-select>
            </div>
            <div class="text-center mb-3">
                <button v-if="selectedMeasurement" @click="selectHandle" class="d-inline-block btn btn-success">Connect</button>
            </div>
        </div>
    </d-col>
</template>

<script>
    import { GoogleAnalyticsV4Service } from '@/main';
    import notification from '@/mixins/notification';

    export default {
        mixins: [notification],

        data() {
            return {
                googleConnectionId: null,
                selectedAccount: null,
                selectedProperty: null,
                selectedMeasurement: null,
                accounts: [],
                properties: [],
                measurements: [],
                isLoading: false,
                isLoaded: false,
            };
        },

        methods: {
            selectHandle() {
                this.$eventHub.$emit(
                    "fill-google-analytics-v4-form",
                    this.googleConnectionId,
                    this.selectedAccount,
                    this.selectedProperty,
                    this.selectedMeasurement.id,
                    this.selectedMeasurement.secret
                );
            },

            async handleSelectingAccount(value) {
                this.selectedAccount = value
                this.googleConnectionId = this.accounts.find(a => a.id === value).connection_id
                this.selectedProperty = null
                this.selectedMeasurement = null
                await this.receiveProperties()
            },

            async handleSelectingProperty(value) {
                this.selectedProperty = value
                this.selectedMeasurement = null
                await this.receiveMeasurements()
            },

            handleSelectingMeasurement(value) {
                this.selectedMeasurement = value
            },

            async receiveAccounts() {
                this.startLoading()
                const accounts = await GoogleAnalyticsV4Service.receiveAccounts()
                this.accounts = accounts.data

                this.finishLoading()
            },

            async receiveProperties() {
                this.startLoading()
                const properties = await GoogleAnalyticsV4Service.receiveProperties(this.googleConnectionId, this.selectedAccount)
                this.properties = properties.data

                this.finishLoading()
            },

            async receiveMeasurements() {
                this.startLoading()
                const measurements = await GoogleAnalyticsV4Service.receiveMeasurements(this.googleConnectionId, this.selectedProperty)
                this.measurements = measurements.data
                this.finishLoading()
            },

            startLoading() {
                this.isLoaded = false
                this.isLoading = true
            },

            finishLoading() {
                this.isLoaded = true
                this.isLoading = false
            },
        },

        async mounted() {
            if (! this.isLoaded) {
                await this.receiveAccounts()
            }
        },
    };
    </script>
